import React, { useState, useEffect, useContext } from 'react';
import { Box, Stack, TextField, Divider, Typography, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import NurseSearchDialog from '../nurses/nurseSearchDialog';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ServiceFormContext } from '../utils/contexts/serviceFormContext';
import { GetDayJSValueFromUTCDate, GetNoToCurrencyFormat, GetNumberFromCurrencyFormat } from '../utils/extensions/functionEx';
import { DATE_DISPLAY_FORMAT } from '../startups/apiConfig';

import dayjs from 'dayjs';

export default function NurseChangeForm(props) {
    const { selectedServiceType } = props;
    const { selectedNurse, selectedPatientService, changeNurseFormInitalState, SetChangeNurseFormValues } = useContext(ServiceFormContext);

    const [cleared, setCleared] = useState(false);
    const [serviceEndDate, setServiceEndDate] = useState('');
    const [serviceStartDate, setServiceStartDate] = useState(dayjs());
    const [serviceCompletedDutyDays, setServiceCompletedDutyDays] = useState(0);
    const [oldNurseCompletedDate, setOldNurseCompletedDate] = useState(dayjs().add(-1, 'day'));
    const [oldNurseCompletedDutyDays, setOldNurseCompletedDutyDays] = useState(0);
    const [oldNurseSalary, setOldNurseSalary] = useState(selectedPatientService ? GetNoToCurrencyFormat(selectedPatientService.nurse_salary) : '0.00');
    const [oldNurseBalanceSalary, setOldNurseBalanceSalary] = useState('0.00');
    const [newNurseStartDate, setNewNurseStartDate] = useState(dayjs());
    const [newNurseDutyDays, setNewNurseDutyDays] = useState(0);
    const [newNurseSalary, setNewNurseSalary] = useState('0.00');
    const [isNurseSearchOpen, setIsNurseSearchOpen] = useState(false);
    const [selectedNewNurse, setSelectedNewNurse] = useState(null);

    useEffect(() => {
        const tempFormValue = { ...changeNurseFormInitalState };
        tempFormValue.serviceId = 0;
        tempFormValue.currentServiceNurseId = 0;
        tempFormValue.currentNurseCompletedDate = dayjs();
        tempFormValue.currentNurseCompletedDays = 0;
        tempFormValue.currentNurseCompletedDaysSalary = 0;
        tempFormValue.newNurseId = 0;
        tempFormValue.newNurseDutyDays = 0;
        tempFormValue.newNurseStartDate = dayjs();
        tempFormValue.newNurseSalary = 0;

        let tempServiceCompletedDutyDays = 0;

        if (selectedPatientService) {
            tempFormValue.serviceId = selectedPatientService.service_id;
            tempFormValue.currentServiceNurseId = selectedPatientService.service_nurse_id;
            tempFormValue.currentNurseCompletedDaysSalary = selectedPatientService.nurse_salary;

            const tempServiceDutyDays = parseInt(selectedPatientService.service_duty_days);
            const tempServiceStartDate = GetDayJSValueFromUTCDate(selectedPatientService.service_start_date);

            if (tempServiceStartDate && tempServiceDutyDays > 0) {
                const tempEndDate = tempServiceStartDate.add(tempServiceDutyDays - 1, 'day')
                setServiceEndDate(tempEndDate.format(DATE_DISPLAY_FORMAT));
            } else {
                setServiceEndDate('');
            }
            setServiceStartDate(tempServiceStartDate);

            if (tempServiceStartDate) {
                let toDate = dayjs();
                let fromDate = dayjs();

                toDate = dayjs(toDate.year().toString() + '-' + (toDate.month() + 1).toString() + '-' + toDate.date().toString());
                fromDate = dayjs(tempServiceStartDate.year().toString() + '-' + (tempServiceStartDate.month() + 1).toString() + '-' + tempServiceStartDate.date().toString());

                tempServiceCompletedDutyDays = toDate.diff(fromDate, 'day') + 1;
            }
            setServiceCompletedDutyDays(tempServiceCompletedDutyDays);
        }
        SetChangeNurseFormValues(tempFormValue);
    }, [selectedPatientService]);

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    useEffect(() => {
        let tempCompletedDutyDays = 0;

        if (oldNurseCompletedDate && selectedPatientService && selectedPatientService.nurse_start_date) {
            const tempNurseStartDate = GetDayJSValueFromUTCDate(selectedPatientService.nurse_start_date);
            tempCompletedDutyDays = oldNurseCompletedDate.diff(tempNurseStartDate, 'day') + 1;
        }
        setOldNurseCompletedDutyDays(tempCompletedDutyDays);
        setNewNurseStartDate(oldNurseCompletedDate ? oldNurseCompletedDate.add(1, 'day') : dayjs());

        const tempFormValue = { ...changeNurseFormInitalState };
        tempFormValue.currentNurseCompletedDate = oldNurseCompletedDate;
        tempFormValue.currentNurseCompletedDays = tempCompletedDutyDays;
        SetChangeNurseFormValues(tempFormValue);
    }, [oldNurseCompletedDate, selectedPatientService]);

    useEffect(() => {
        let tempOldNurseBalanceSalary = 0;
        if (oldNurseSalary && selectedPatientService) {
            const tempOldNurseSalary = GetNumberFromCurrencyFormat(oldNurseSalary);
            tempOldNurseBalanceSalary = tempOldNurseSalary - selectedPatientService.nurse_paid_salary;
        }
        setOldNurseBalanceSalary(GetNoToCurrencyFormat(tempOldNurseBalanceSalary));
    }, [oldNurseSalary, selectedPatientService]);

    useEffect(() => {
        let tempServiceDutyDays = 0, tempBalanceServiceDutyDays = 0;
        let tempServiceCompletedDutyDays = 0;

        if (selectedPatientService) {
            tempServiceDutyDays = selectedPatientService.service_duty_days;
            tempServiceCompletedDutyDays = selectedPatientService.service_completed_days
        }
        tempServiceCompletedDutyDays += parseInt(oldNurseCompletedDutyDays);
        tempBalanceServiceDutyDays = tempServiceDutyDays - tempServiceCompletedDutyDays;

        setNewNurseDutyDays(tempBalanceServiceDutyDays);

        const tempFormValue = { ...changeNurseFormInitalState };
        tempFormValue.newNurseDutyDays = tempBalanceServiceDutyDays;
        tempFormValue.newNurseStartDate = newNurseStartDate;
        SetChangeNurseFormValues(tempFormValue);
    }, [newNurseStartDate, oldNurseCompletedDutyDays, selectedPatientService]);

    const handleNurseSearchClick = () => {
        setIsNurseSearchOpen(true);
    }

    const handleNurseSearchCloseClick = () => {
        setIsNurseSearchOpen(false);
    }

    const handleNurseSelectedClick = (nurseDbRow) => {
        setIsNurseSearchOpen(false);
        setSelectedNewNurse(nurseDbRow);

        const tempFormValue = { ...changeNurseFormInitalState };
        tempFormValue.newNurseId = nurseDbRow && nurseDbRow.id && nurseDbRow.id > 0 ? nurseDbRow.id : 0;

        if (selectedPatientService) {
            tempFormValue.serviceId = selectedPatientService.service_id;
            tempFormValue.currentServiceNurseId = selectedPatientService.service_nurse_id;
            tempFormValue.currentNurseCompletedDaysSalary = selectedPatientService.nurse_salary;
        }
        SetChangeNurseFormValues(tempFormValue);
    }


    return (
        <Box sx={{ padding: "16px", maxHeight: '80vh', overflowY: 'auto' }}>
            <Stack>
                {
                    isNurseSearchOpen &&
                    <NurseSearchDialog isOpen={isNurseSearchOpen} handleCloseClick={handleNurseSearchCloseClick} handleNurseSelectClick={handleNurseSelectedClick} />
                }
                <Box sx={{ paddingBottom: "25px" }}>
                    <Stack>
                        <Typography gutterBottom variant="subtitle2">
                            Service Details
                        </Typography>
                        <Divider />
                    </Stack>
                </Box>

                <Box>
                    <Grid container spacing={2}>

                        <Grid size={3}>
                            <TextField size="small" fullWidth
                                label="Service Type" value={selectedServiceType ? selectedServiceType.service_type_name : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="Start Date"
                                value={serviceStartDate.format(DATE_DISPLAY_FORMAT)}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={1}>
                            <TextField size="small" fullWidth type='number' label="Duty Days" value={selectedPatientService.service_duty_days}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="End Date"
                                value={serviceEndDate}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth type='number'
                                label="Completed Duty Days"
                                value={serviceCompletedDutyDays}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid><Grid size={2}></Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="Service Fee"
                                value={GetNoToCurrencyFormat(selectedPatientService.service_total_salary)}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Paid Amount" value={GetNoToCurrencyFormat(selectedPatientService.service_paid_amount)}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Discount Amount" value={GetNoToCurrencyFormat(selectedPatientService.service_discount)}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Refund Amount" value={GetNoToCurrencyFormat(selectedPatientService.service_refund_amount)}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Balance Amount" value={GetNoToCurrencyFormat(selectedPatientService.service_balance_amount)}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}></Grid>

                    </Grid>
                </Box>

                <Box sx={{ paddingBottom: "25px", marginTop: "15px" }}>
                    <Stack>
                        <Typography gutterBottom variant="subtitle2">
                            Current Nurse Details
                        </Typography>
                        <Divider />
                    </Stack>
                </Box>
                <Box>
                    <Grid container spacing={2}>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Nurse Name"
                                value={selectedNurse ? selectedNurse.nurseName : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Mobile No"
                                value={selectedNurse ? selectedNurse.phoneNo : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Advance Amount" value={selectedNurse ? selectedNurse.advanceAmount : '0.00'}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>

                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="Start Date"
                                value={GetDayJSValueFromUTCDate(selectedPatientService.nurse_start_date).format(DATE_DISPLAY_FORMAT)}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={1}>
                            <TextField size="small" fullWidth type='number' label="Duty Days" value={selectedPatientService.nurse_duty_days}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <DatePicker format="DD/MM/YYYY"
                                label="Completed Date" maxDate={dayjs()}
                                minDate={dayjs().add(-3, 'day')}
                                value={oldNurseCompletedDate}
                                onChange={(newValue) => {
                                    setOldNurseCompletedDate(newValue);
                                }}
                                slotProps={{
                                    textField: {
                                        size: "small", fullWidth: "true", required: "true",
                                        error: true,
                                        helperText: 'Enter current nurse completed date'
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => setCleared(true)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth type='number'
                                label="Completed Duty Days"
                                value={oldNurseCompletedDutyDays}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="Nurse Salary"
                                error={true}
                                helperText={'Enter current nurse salary'}
                                value={oldNurseSalary}
                                onChange={(event) => {
                                    setOldNurseSalary(event.target.value ?? 0);
                                }}
                                onBlur={(event) => {
                                    setOldNurseSalary(GetNoToCurrencyFormat(event.target.value ?? 0));

                                    const tempFormValue = { ...changeNurseFormInitalState };
                                    tempFormValue.currentNurseCompletedDaysSalary = event.target.value ?? 0;
                                    SetChangeNurseFormValues(tempFormValue);
                                }}
                                onFocus={(event) => {
                                    const tempValue = parseFloat(event.target.value ?? 0);
                                    if (tempValue > 0) {
                                        setOldNurseSalary(GetNumberFromCurrencyFormat(event.target.value));
                                    } else {
                                        setOldNurseSalary('');
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={1}>
                            <TextField size="small" fullWidth label="Paid Nurse Salary"
                                value={GetNoToCurrencyFormat(selectedPatientService.nurse_paid_salary)}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="Balance Nurse Salary"
                                value={oldNurseBalanceSalary}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ paddingBottom: "25px", marginTop: "15px" }}>
                    <Stack>
                        <Typography gutterBottom variant="subtitle2">
                            New Nurse Details
                        </Typography>
                        <Divider />
                    </Stack>
                </Box>

                <Box>
                    <Grid container spacing={2}>
                        <Grid size={4}>
                            <TextField size="small" fullWidth required error
                                helperText='Select a new nurse'
                                label="Nurse Name"
                                value={selectedNewNurse ? selectedNewNurse.nurse_name : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Mobile No"
                                value={selectedNewNurse ? selectedNewNurse.phone : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Advance Amount" value={selectedNewNurse ? GetNoToCurrencyFormat(selectedNewNurse.advance_amount) : '0.00'}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <Button variant="contained" onClick={handleNurseSearchClick}>Search Nurse</Button>
                        </Grid>
                        <Grid size={2}>
                            <DatePicker format="DD/MM/YYYY"
                                label="Start Date" maxDate={dayjs()}
                                minDate={dayjs().add(-3, 'day')}
                                value={newNurseStartDate}
                                onChange={(newValue) => {
                                    setNewNurseStartDate(newValue);
                                }}
                                slotProps={{
                                    textField: {
                                        size: "small", fullWidth: "true", required: "true",
                                        error: true,
                                        helperText: 'Enter new nurse start date'
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => setCleared(true)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={1}>
                            <TextField size="small" fullWidth required type='number' label="Duty Days" value={newNurseDutyDays}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="New Nurse Salary"
                                error={true}
                                helperText={'Enter new nurse salary'}
                                value={newNurseSalary}
                                onChange={(event) => {
                                    setNewNurseSalary(event.target.value ?? 0);
                                }}
                                onBlur={(event) => {
                                    setNewNurseSalary(GetNoToCurrencyFormat(event.target.value ?? 0));
                                    const tempFormValue = { ...changeNurseFormInitalState };
                                    tempFormValue.newNurseSalary = event.target.value ?? 0;
                                    SetChangeNurseFormValues(tempFormValue);
                                }}
                                onFocus={(event) => {
                                    const tempValue = parseFloat(event.target.value ?? 0);
                                    if (tempValue > 0) {
                                        setNewNurseSalary(GetNumberFromCurrencyFormat(event.target.value));
                                    } else {
                                        setNewNurseSalary('');
                                    }
                                }}
                            />
                        </Grid>

                    </Grid>
                </Box>


                <Box sx={{ paddingBottom: "25px", marginTop: "15px" }}>
                    <Stack>
                        <Typography gutterBottom variant="subtitle2">
                            Patient Details
                        </Typography>
                        <Divider />
                    </Stack>
                </Box>

                <Box>
                    <Grid container spacing={2}>
                        <Grid size={5}>
                            <TextField size="small" fullWidth required
                                label="Patient Name" value={selectedPatientService.patient_name}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth required label="Mobile No"
                                value={selectedPatientService.patient_phone1}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={3}>
                            <TextField size="small" fullWidth required
                                label="Place" value={selectedPatientService.patient_place}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth type='number'
                                label="Delivery No" value={selectedPatientService.patient_delivery_no}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth label="Address"
                                helperText="" multiline
                                rows={4} value={selectedPatientService.patient_address}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Bus Route" helperText=""
                                multiline rows={4} value={selectedPatientService.patient_bus_route}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Stack spacing={2}>
                                <TextField size="small" fullWidth label="Phone 1"
                                    value={selectedPatientService.patient_phone2}
                                    slotProps={{
                                        input: {
                                            readOnly: true
                                        },
                                    }}
                                />

                                <TextField size="small" fullWidth label="Phone 2"
                                    value={selectedPatientService.patient_phone3}
                                    slotProps={{
                                        input: {
                                            readOnly: true
                                        },
                                    }}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={8}>
                            <TextField size="small" fullWidth
                                label="Notes" helperText="" multiline
                                rows={4} value={selectedPatientService.service_remarks}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
        </Box>

    );
}